import { GridColDef } from "@mui/x-data-grid";
import { AppTable } from "components/molecules";
import { TableHelper } from "helpers";
import { usePaginationRequest } from "hooks/useRequest";
import { ILocation } from "model";
import { IGetAllLocationByZoneRequest } from "model/ILocation";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "redux/configurations/reduxHooks";
import { MasterDataApiService } from "services";
import { I18nTranslator, translations } from "utils/i18n";

const Location = (props: { zoneId: string }) => {
  const params = useParams<{
    id: string;
    code: string;
  }>();
  const dispatch = useAppDispatch();
  const [request, setRequest] = useState<IGetAllLocationByZoneRequest>({
    zoneCode: params.code,
    pageNumber: 1,
    pageSize: 100,
    orderBy: "locationName",
  });
  const { loading, result } = usePaginationRequest<
    IGetAllLocationByZoneRequest,
    ILocation[]
  >(request, MasterDataApiService.getAllLocations);
  const handleChangePage = (pageNumber: number) => {
    setRequest({
      ...request,
      pageNumber: pageNumber,
      searchText: "",
    });
  };
  const handleChangeSearchText = (searchText: string) => {
    setRequest({
      ...request,
      searchText: searchText,
    });
  };
  const _handlePageSizeChange = (pageSize: number) => {
    setRequest({ ...request, pageSize: pageSize });
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "locationName",
      headerName: I18nTranslator(translations.masterData.locationName),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "lineCode",
      headerName: I18nTranslator(translations.masterData.lineCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "currentPalletCode",
      headerName: I18nTranslator(translations.receive.palletCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "palletQuantity",
      headerName: I18nTranslator(translations.masterData.goods),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "levelID",
      headerName: I18nTranslator(translations.masterData.levelID),
      size: "small",
      align: "center",
    }),
    TableHelper.createCell({
      field: "lengthID",
      headerName: I18nTranslator(translations.masterData.order),
      size: "small",
      align: "center",
    }),
    TableHelper.renderActivationCell(),
    TableHelper.createCell({
      field: "description",
      headerName: I18nTranslator(translations.masterData.description),
      size: "medium",
      align: "left",
    }),
    TableHelper.createCell({
      field: "locationCode",
      headerName: I18nTranslator(translations.masterData.locationCode),
      size: "small",
      align: "left",
    }),
  ];
  return (
    <AppTable<ILocation>
      loading={loading}
      data={result}
      columns={COLUMNS}
      onSearch={handleChangeSearchText}
      searchPlaceholder={I18nTranslator(
        translations.placeholder.searchLocationZoneDetail
      )}
      onChangePage={handleChangePage}
      hideHeader
      actionColumnProps={{ hideEdit: true, hideImport: true }}
      defaultHeaderTable={300}
      onPageSizeChange={_handlePageSizeChange}
    />
  );
};

export default Location;
